import { PureComponent } from 'react';

import * as styles from './commit-graph.styled';

export type NodeProps = {
  onClick: (id: string) => void;
  hash: string;
  x: number;
  y: number;
  color: number;
  isFocused: boolean;
};

type NodeState = {
  isMouseOver: boolean;
};

export default class Node extends PureComponent<NodeProps, NodeState> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    isFocused: false,
    onClick: () => {},
  };

  // firefox does not support css `r` property
  // so we need to set it on node from js
  state = {
    isMouseOver: false,
  };

  onClick = () => {
    const { onClick, hash } = this.props;

    onClick(hash);
  };

  handleMouseOver = () => {
    this.setState({ isMouseOver: true });
  };

  handleMouseOut = () => {
    this.setState({ isMouseOver: false });
  };

  render() {
    const { color, isFocused, x, y } = this.props;
    const { isMouseOver } = this.state;

    /* TODO: fix this:
    onMouseOver must be accompanied by onFocus for accessibility
    onMouseOut must be accompanied by onBlur for accessibility
    */
    return (
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      <styles.Node
        cx={x}
        cy={y}
        r={isFocused || isMouseOver ? 5 : 3}
        isFocused={isFocused}
        colorIndex={color % 6}
        onClick={this.onClick}
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
      />
    );
  }
}
